import { IconContainer } from "../../Buttons/IconContainer"
import ViewsIcon from "../../../public/images/icons/views.svg";
import { MediaListItem } from "@jconradi/tutu-porn-api-client/src/users";

export const ViewsBadge = ({ media }: { media: MediaListItem}) => {
    return (
        <IconContainer icon={<ViewsIcon className="w-4 h-4 overlay-badge" />} responsiveText={false} className="absolute bottom-0 left-0 m-1" labelClassName="text-sm overlay-badge" label={media.views.toLocaleString()} />
    )
}